import apiClient from '@/shared/services/api';
import type { ApiResponse } from '@/features/auth/services/authApi';
import type { PagedResult } from './userApi';

export interface AuditLogEntry {
  id: string;
  entityName: string;
  entityId: string;
  action: string;
  oldValues: string | null;
  newValues: string | null;
  changedBy: string | null;
  changedAt: string;
  ipAddress: string | null;
  additionalInfo: string | null;
}

export interface AuditLogParams {
  search?: string;
  entityName?: string;
  action?: string;
  from?: string;
  to?: string;
  pageNumber?: number;
  pageSize?: number;
}

export const auditLogsApi = {
  getPaged: async (params: AuditLogParams = {}): Promise<PagedResult<AuditLogEntry>> => {
    const { data } = await apiClient.get<ApiResponse<PagedResult<AuditLogEntry>>>(
      '/AuditLogs',
      { params }
    );
    return data.data;
  },
};
